// Services
import apiClient from '@/services/AccountClient'

export default {
  fetchAll (options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/country-groups',
      undefined,
      options
    )
  },
  update (data, options) {
    return apiClient.sendRequest(
      'PUT',
      'api/admin/v1/country-groups',
      data,
      options
    )
  }
}
